export default "__VITE_ASSET__ce2ba12d__"